import {Component, Input, OnInit} from '@angular/core';
import {PatientSearchUtil} from "../../utilities/patient-search.util";
import {ConvertDobPipe} from "../../pipes/convert-dob.pipe";
import {WindowRef} from "@progress/kendo-angular-dialog";
import {Subscription} from "rxjs";
import {ProcessAbbyyService} from "../../../core/services/process-abbyy.service";
import {NotificationService} from "@progress/kendo-angular-notification";
import {showNotification} from "../../utilities/notificaton.util";
import {LoaderService} from "../../../core/services/loader.service";

@Component({
    selector: 'app-patient-review',
    templateUrl: './patient-review.component.html',
    styleUrls: ['./patient-review.component.scss'],
    standalone: false
})
export class PatientReviewComponent implements OnInit{
  protected readonly PatientSearchUtil = PatientSearchUtil;
  public markingAsError: Subscription;
  @Input() formId: any;
  @Input() patientMatched: any;
  @Input() patientSearched: any;
  public reviewedPatient: any;
  public newPatientSearch: any;
  public newPatientMatch: any;
  public fnameChecked = false;
  public mnameChecked = false;
  public lnameChecked = false;
  public suffixChecked = false;
  public dobChecked = false;
  public genderChecked = false;
  public streetChecked = false;
  public cityChecked = false;
  public stateChecked = false;
  public zipChecked = false;
  public phoneChecked = false;
  constructor(private abbyyService: ProcessAbbyyService, private notificationService: NotificationService,
              private windowRef: WindowRef, private loader: LoaderService) {}
  ngOnInit(): void {
    this.newPatientSearch = {
      fname: PatientSearchUtil.cleanEmptyString(this.patientSearched.fname),
      mname: PatientSearchUtil.cleanEmptyString(this.patientSearched.mname),
      lname: PatientSearchUtil.cleanEmptyString(this.patientSearched.lname),
      suffix: PatientSearchUtil.cleanEmptyString(this.patientSearched.suffix),
      dob: PatientSearchUtil.cleanEmptyString(this.patientSearched.dob),
      gender: this.patientSearched.gender !== undefined && this.patientSearched.gender !== null ?
          PatientSearchUtil.cleanEmptyString(this.patientSearched.gender) : '',
      street: PatientSearchUtil.cleanEmptyString(this.patientSearched.street),
      city: PatientSearchUtil.cleanEmptyString(this.patientSearched.city),
      state: this.patientSearched.state !== undefined && this.patientSearched.state !== null
          ? PatientSearchUtil.cleanEmptyString(this.patientSearched.state) : '',
      zip: PatientSearchUtil.cleanEmptyString(this.patientSearched.zip),
      phone: this.patientSearched.phone !== null && this.patientSearched.phone !== undefined ?
          PatientSearchUtil.cleanEmptyString(this.patientSearched.phone.replace('(', '').replace(')', '').replace('-', '').replace(' ', '')) : '',
    };
    if (this.newPatientSearch.dob.length > 0) {
      this.newPatientSearch.dob = ConvertDobPipe.prototype.transform(this.newPatientSearch.dob);
    }
    this.newPatientMatch = {
      fname: this.patientMatched.fname !== undefined ? PatientSearchUtil.cleanEmptyString(this.patientMatched.fname) : '',
      mname: this.patientMatched.mname !== undefined ? PatientSearchUtil.cleanEmptyString(this.patientMatched.mname) : '',
      lname: this.patientMatched.lname !== undefined ? PatientSearchUtil.cleanEmptyString(this.patientMatched.lname) : '',
      suffix: this.patientMatched.suffix !== undefined ? PatientSearchUtil.cleanEmptyString(this.patientMatched.suffix) : '',
      dob: this.patientMatched.dob !== undefined ? PatientSearchUtil.cleanEmptyString(this.patientMatched.dob) : '',
      gender: this.patientMatched.gender !== undefined
      && this.patientMatched.gender !== null ? PatientSearchUtil.cleanEmptyString(this.patientMatched.gender) : '',
      street: this.patientMatched.street !== undefined ? PatientSearchUtil.cleanEmptyString(this.patientMatched.street) : '',
      city: this.patientMatched.city !== undefined ? PatientSearchUtil.cleanEmptyString(this.patientMatched.city) : '',
      state: this.patientMatched.state !== undefined ? PatientSearchUtil.cleanEmptyString(this.patientMatched.state) : '',
      zip: this.patientMatched.zip !== undefined ? PatientSearchUtil.cleanEmptyString(this.patientMatched.zip) : '',
      phone: this.patientMatched.phone !== undefined ? PatientSearchUtil.cleanEmptyString(this.patientMatched.phone.replace(/( ) /g, '')) : '',
    };
    this.reviewedPatient = Object.assign({}, this.newPatientSearch);
    this.reviewedPatient.id = this.patientMatched.id;
    this.reviewedPatient.is_iehp_patient = this.patientMatched.is_iehp_patient;
    this.reviewedPatient.iehp_pt = this.patientMatched.iehp_pt !== undefined ? this.patientMatched.iehp_pt : undefined;
  }
  public onFnameChange(val: any) {
    val ? this.reviewedPatient.fname = this.patientMatched.fname
        : this.reviewedPatient.fname = this.patientSearched.fname;
  }

  public onMnameChange(val: any) {
    val ? this.reviewedPatient.mname = this.patientMatched.mname
        : this.reviewedPatient.mname = this.patientSearched.mname;
  }

  public onLnameChange(val: any) {
    val ? this.reviewedPatient.lname = this.patientMatched.lname
        : this.reviewedPatient.lname = this.patientSearched.lname;
  }

  public onSuffixChange(val: any) {
    val ? this.reviewedPatient.suffix = this.patientMatched.suffix
        : this.reviewedPatient.suffix = this.patientSearched.suffix;
  }

  public onGenderChange(val: any) {
    val ? this.reviewedPatient.gender = this.patientMatched.gender
        : this.reviewedPatient.gender = this.patientSearched.gender;
  }

  public onDobChange(val: any) {
    val ? this.reviewedPatient.dob = this.patientMatched.dob
        : this.reviewedPatient.dob = this.patientSearched.dob;
  }

  public onStreetChange(val: any) {
    val ? this.reviewedPatient.street = this.patientMatched.street
        : this.reviewedPatient.street = this.patientSearched.street;
  }

  public onCityChange(val: any) {
    val ? this.reviewedPatient.city = this.patientMatched.city
        : this.reviewedPatient.city = this.patientSearched.city;
  }

  public onStateChange(val: any) {
    val ? this.reviewedPatient.state = this.patientMatched.state
        : this.reviewedPatient.state = this.patientSearched.state;
  }

  public onZipChange(val: any) {
    val ? this.reviewedPatient.zip = this.patientMatched.zip
        : this.reviewedPatient.zip = this.patientSearched.zip;
  }

  public onPhoneChange(val: any) {
    val ? this.reviewedPatient.phone = this.patientMatched.phone
        : this.reviewedPatient.phone = this.patientSearched.phone;
  }

  public confirm() {
    if (this.patientMatched.form !== undefined) {
      this.reviewedPatient.form = this.patientMatched.form;
    }
    this.windowRef.close({ptReviewed: this.reviewedPatient, rejected: false});
  }

  public close(): void {
    this.windowRef.close();
  }
  async markAsInvalid(status: any) {
    if (this.patientMatched.form !== undefined) {
      this.reviewedPatient.form = this.patientMatched.form;
    }
    try {
      this.loader.show('Marking as Error ...');
      await this.abbyyService.markAsError(this.formId, status, this.reviewedPatient);
      this.windowRef.close({rejected: true});
    } catch (err) {
      showNotification('An Error Occurred', 'error', this.notificationService)
    } finally {
      this.loader.hide();
    }
    // this.markingAsError = this.abbyyService.markAsError(this.formId, status, this.reviewedPatient).subscribe({
    //   next: (res) => {
    //     this.windowRef.close({rejected: true});
    //     this.markingAsError.unsubscribe();
    //   },
    //   error: (err) => {
    //     showNotification('An Error Occurred', 'error', this.notificationService)
    //     this.markingAsError.unsubscribe();
    //   }
    // });
  }
}
